export interface LanguageOption {
  value: string;
  label: string;
}

export interface LanguageGroup {
  group: string;
  items: LanguageOption[];
}

export const LANGUAGE_GROUPS: LanguageGroup[] = [
  {
    group: "Common",
    items: [
      { value: "en", label: "English" },
      { value: "de", label: "German" },
      { value: "fr", label: "French" },
      { value: "es", label: "Spanish" },
      { value: "it", label: "Italian" },
      { value: "nl", label: "Dutch" },
      { value: "pt", label: "Portuguese" },
      { value: "pl", label: "Polish" },
      { value: "tr", label: "Turkish" },
    ],
  },
  {
    group: "European",
    items: [
      { value: "da", label: "Danish" },
      { value: "el", label: "Greek" },
      { value: "bg", label: "Bulgarian" },
      { value: "cs", label: "Czech" },
      { value: "fi", label: "Finnish" },
      { value: "hr", label: "Croatian" },
      { value: "hu", label: "Hungarian" },
      { value: "nb", label: "Norwegian Bokmål" },
      { value: "ro", label: "Romanian" },
      { value: "ru", label: "Russian" },
      { value: "sk", label: "Slovak" },
      { value: "sl", label: "Slovenian" },
      { value: "sr", label: "Serbian" },
      { value: "sv", label: "Swedish" },
      { value: "lv", label: "Latvian" },
      { value: "lt", label: "Lithuanian" },
      { value: "et", label: "Estonian" },
    ],
  },
  {
    group: "Asian",
    items: [
      { value: "zh", label: "Chinese" },
      { value: "ko", label: "Korean" },
      { value: "ja", label: "Japanese" },
    ],
  },
  {
    group: "Regional & variants",
    items: [
      { value: "en-GB", label: "English (UK)" },
      { value: "en-US", label: "English (US)" },
      { value: "en-US-DICT", label: "English (US, dictionary)" },
      { value: "de-DE", label: "German (Germany)" },
      { value: "fr-FR", label: "French (France)" },
      { value: "es-ES", label: "Spanish (Spain)" },
      { value: "it-IT", label: "Italian (Italy)" },
      { value: "nl-NL", label: "Dutch (Netherlands)" },
      { value: "pt-PT", label: "Portuguese (Portugal)" },
      { value: "pl-PL", label: "Polish (Poland)" },
      { value: "da-DK", label: "Danish (Denmark)" },
      { value: "el-GR", label: "Greek (Greece)" },
      { value: "bg-BG", label: "Bulgarian (Bulgaria)" },
      { value: "cs-CZ", label: "Czech (Czechia)" },
      { value: "fi-FI", label: "Finnish (Finland)" },
      { value: "hr-HR", label: "Croatian (Croatia)" },
      { value: "hr-BA", label: "Croatian (Bosnia & Herzegovina)" },
      { value: "hu-HU", label: "Hungarian (Hungary)" },
      { value: "nb-NO", label: "Norwegian Bokmål (Norway)" },
      { value: "ro-RO", label: "Romanian (Romania)" },
      { value: "ru-RU", label: "Russian (Russia)" },
      { value: "sk-SK", label: "Slovak (Slovakia)" },
      { value: "sl-SI", label: "Slovenian (Slovenia)" },
      { value: "sr-Latn-RS", label: "Serbian (Latin)" },
      { value: "sv-SE", label: "Swedish (Sweden)" },
      { value: "tr-TR", label: "Turkish (Turkey)" },
      { value: "zh-CN", label: "Chinese (China)" },
      { value: "ko-KR", label: "Korean (South Korea)" },
      { value: "ja-JP", label: "Japanese (Japan)" },
      { value: "lv-LV", label: "Latvian (Latvia)" },
      { value: "lt-LT", label: "Lithuanian (Lithuania)" },
      { value: "et-EE", label: "Estonian (Estonia)" },
    ],
  },
];

const LABELS: Record<string, string> = Object.fromEntries(
  LANGUAGE_GROUPS.flatMap((g) => g.items.map((i) => [i.value, i.label])),
);

export const languageLabel = (code: string): string => LABELS[code] ?? code;
